import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { LocalizationService } from '../../../../Core/Localization/services/localization.service';
import { spamTriggerWords } from '../../../../Common/TargetingShared/misc/spamTriggerWords';
import { WireModel } from '../../models/wire.model';
import { WireService } from '../../services/wire.service';


export class WireHeaderAssessmentMessage {
    headline: string[] = [];
    subHeadline: string[] = [];
    dateline: string[] = [];
    companyName: string[] = [];
}

@Injectable()
export class WireHeaderEditorService implements OnDestroy {
    wire: WireModel;

    private headerAssessmentMessages: WireHeaderAssessmentMessage = new WireHeaderAssessmentMessage();
    private headerAssessmentMessages$: BehaviorSubject<WireHeaderAssessmentMessage> = new BehaviorSubject<WireHeaderAssessmentMessage>(null);
    subscriptions: Subscription[] = [];

    constructor(
        public wireService: WireService,
        public localizationService: LocalizationService
    ) {
        this.subscriptions.push(
            this.wireService.currentResource$.subscribe(wire => {
                if (!wire) {
                    return;
                }
                this.wire = wire;
                this.assessWireHeader();
            })
        );
    }

    ngOnDestroy() {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }

    getHeaderAssessmentMessages() {
        return this.headerAssessmentMessages$;
    }

    updateHeader(assessmentMessages: WireHeaderAssessmentMessage): void {
        this.headerAssessmentMessages = assessmentMessages;
        this.headerAssessmentMessages$.next(this.headerAssessmentMessages);
    }

    assessWireHeader() {
        this.headerAssessmentMessages.headline = this.assessHeadline(this.wire.headline);
        this.headerAssessmentMessages.subHeadline = this.assessSubHeadline(this.wire.headline, this.wire.subHeadline);
        this.headerAssessmentMessages.dateline = this.assessDateline(this.wire.dateline);
        this.headerAssessmentMessages.companyName = this.assessCompanyName(this.wire.companyName);
        this.headerAssessmentMessages$.next(this.headerAssessmentMessages);
    }

    assessHeadline(subjectLine: string): string[] {
        const messages: string[] = [];

        if (!subjectLine) {
            return messages;
        }

        if (subjectLine.length >= 60 || subjectLine.trim().split(/\s+/).length > 10) {
            messages.push(this.localizationService.transform('Amplify.wire.header.headline.popoverMessage.maxLengh'));
        }

        const spamWords = spamTriggerWords.filter(x => {
            const foundIndex = subjectLine.toLowerCase().indexOf(x.toLowerCase());
            if (foundIndex > -1) {
                return (
                    // deal with cases when the subject line contains 'there' and the word list contains 'here'
                    (foundIndex === 0 || subjectLine[foundIndex - 1] === ' ')
                    && (foundIndex + x.length === subjectLine.length || subjectLine[foundIndex + x.length] === ' ')
                );
            }
        });

        if (spamWords?.length > 0) {
            messages.push(this.localizationService
                .transform('Amplify.wire.header.headline.popoverMessage.spamWords', {
                    spamWords: spamWords.join(', ')
                })
            );
        }

        return messages;
    }

    assessSubHeadline(previewText: string, subjectLine: string): string[] {
        const messages: string[] = [];
        if (previewText && subjectLine && (previewText.trim() === subjectLine.trim())) {
            messages.push(this.localizationService.transform('Amplify.wire.header.subHeadline.popoverMessage.sameAsHeadline'));
        }
        return messages;
    }

    assessDateline(fromName: string): string[] {
        const messages: string[] = [];
        return messages;
    }

    assessCompanyName(replyEmail: string): string[] {
        const messages: string[] = [];
        return messages;
    }
}
